import React from 'react';
import PropTypes from 'prop-types';

import { formatPrice } from 'common/formatters';

import SrCard from 'client/components/SrCard/SrCard';
import SrText from 'client/components/SrText';
import SrLinkUrlButton from 'client/components/SrLinkUrlButton';

import './UPReferralLink.less';

const UPReferralLink = ({ utilityPartner, maxWidth = 'unset', referralEarnings = 0 }) => {
  return (
    <SrCard maxWidth={maxWidth} padding="24px 24px 34px" margin="0 0 32px">
      <div styleName="containerBox">
        <div styleName="contentBox">
          <div styleName="referralEarningsContainer">
            <span styleName="referralEarningsText">
              Referral Earned:{` ${formatPrice(referralEarnings)} `}
            </span>
            <a
              href="https://sunroomrentals.com/learn-more-utility-referrals"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SrText styleName="referralEarningsLearnMore">Learn More</SrText>
            </a>
          </div>
          <div styleName="titleBox">
            <span styleName="titleText">
              Get
              <span styleName="titleText green">
                {` ${formatPrice(utilityPartner.defaultReferralAmount)}, `}
              </span>
              give
              <span styleName="titleText gold">
                {` ${formatPrice(utilityPartner.defaultReferralAmount)} `}
              </span>
              <br />
              when you refer a property manager.
            </span>
          </div>
          <SrLinkUrlButton
            className="green"
            buttonText="Copy Link"
            href={`https://utilityprofit.com/refer/${utilityPartner.slug}`}
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
      </div>
    </SrCard>
  );
};

UPReferralLink.propTypes = {
  referralEarnings: PropTypes.number,
  maxWidth: PropTypes.string,
  utilityPartner: PropTypes.object.isRequired,
};

UPReferralLink.displayName = 'UPReferralLink';

export default UPReferralLink;
